import { Show } from "@refinedev/antd";

export const SettingShow = () => {
  return (
    <Show title="Settings" headerButtons={() => null}>
      Coming soon!
    </Show>
  );
};
